import React from 'react'
import {
  BookOpenIcon,
  BatteryLowIcon,
  BriefcaseIcon,
  MeditationIcon,
} from 'lucide-react'
const MeditationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={props.className}
  >
    <path d="M12 4a4 4 0 0 1 2 7.5" />
    <path d="M16 16a4 4 0 0 1-8 0" />
    <path d="m18 18-5.3-5.3" />
    <path d="m6 18 5.3-5.3" />
    <path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20z" />
  </svg>
)
export function SolutionSection() {
  return (
    <section
      id="solucion"
      className="py-20 bg-gradient-to-b from-white to-purple-50"
    >
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-purple-800">
            Por Qué Lo Que Ya Probaste No Funcionó
          </h2>
          <div className="space-y-6 mb-16">
            <div className="bg-white p-6 rounded-xl shadow-sm flex items-start">
              <div className="mr-4 text-purple-600 mt-1">
                <BookOpenIcon size={24} />
              </div>
              <div>
                <h3 className="font-semibold text-lg mb-1 text-purple-800">
                  Libros de autoayuda y frases motivacionales
                </h3>
                <p className="text-gray-600">
                  Te animan por un rato, pero no cambian nada de raíz.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex items-start">
              <div className="mr-4 text-purple-600 mt-1">
                <BatteryLowIcon size={24} />
              </div>
              <div>
                <h3 className="font-semibold text-lg mb-1 text-purple-800">
                  Técnicas de relajación superficiales
                </h3>
                <p className="text-gray-600">
                  Calman por minutos, pero tu mente vuelve a encenderse en
                  cuanto termina la práctica.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex items-start">
              <div className="mr-4 text-purple-600 mt-1">
                <BriefcaseIcon size={24} />
              </div>
              <div>
                <h3 className="font-semibold text-lg mb-1 text-purple-800">
                  Empujarte a trabajar más duro o ignorar la ansiedad
                </h3>
                <p className="text-gray-600">
                  Solo te acerca al agotamiento y al vacío.
                </p>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm flex items-start">
              <div className="mr-4 text-purple-600 mt-1">
                <MeditationIcon size={24} />
              </div>
              <div>
                <h3 className="font-semibold text-lg mb-1 text-purple-800">
                  Meditación sin guía
                </h3>
                <p className="text-gray-600">
                  Intentaste sentarte en silencio, pero tu mente no paraba… y te
                  frustraste al no sentir resultados.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-purple-800 text-white p-8 rounded-2xl shadow-lg">
            <h3 className="text-2xl font-semibold mb-4 text-center">
              Mi Momento de Quiebre
            </h3>
            <p className="mb-4">
              Yo lo viví. Pasé de no tener nada —literalmente recoger botellas
              en la playa para sobrevivir— a construir un éxito que nunca
              imaginé… y luego perderlo todo.
            </p>
            <p className="mb-4">
              Ese vacío me destrozó. Pero en el silencio descubrí algo: el cielo
              estaba dentro de mí. Recordé lo que Jesús enseñó: "El reino de
              Dios está en vuestro interior."
            </p>
            <p>
              Ahí encontré paz, fe y un don: ayudar a otros a transformar sus
              vidas.
            </p>
          </div>
          <div className="mt-16 bg-white p-8 rounded-2xl shadow-lg border-l-4 border-purple-600">
            <h3 className="text-2xl font-semibold mb-4 text-purple-800">
              La Solución Única
            </h3>
            <p className="text-gray-700 mb-4">
              Durante 30 días te guiaré paso a paso con el Método CIA:
              Meditaciones con frecuencias binaurales que llevan tu mente a los
              estados Theta, Alpha y Delta, donde puedes reprogramar desde la
              raíz.
            </p>
            <p className="text-gray-700">
              En este estado tu mente se aquieta, tu espíritu se fortalece y
              recuperas la claridad y propósito que estaban adentro todo este
              tiempo.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
